import { EventManager } from 'interfaces/eventManager.interface';
import { useVisualisationEventManagerBody } from '../hooks/useVisualisationEventManagerBody.hooks';
import EventManagerDays from 'components/wrapperEventManager/eventManagerDays.component';
import { StyleEventCard } from 'enum/styleEventCard.enum';
import VisualisationEventManagerCharts from './visualisationEventManagerCharts.component';

interface VisualisationEventManagerBodyProps {
  eventManager: EventManager;
  duration: number
}


function VisualisationEventManagerBody( { eventManager, duration }: VisualisationEventManagerBodyProps ) {

  const {  currentEventManager, engagementsMap, displayDate, chartsDatas, safetyCross, elementRef, getParticipantById, isDateInMap } = useVisualisationEventManagerBody( eventManager, duration );

  return (
    <div
      className='relative flex max-2xl:flex-col w-full h-full overflow-y-auto'
      ref={ elementRef }
      style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      {
        currentEventManager && (
          <>
            <div className='max-2xl:order-last h-full 2xl:w-[32%] 2xl:min-w-[450px]'>
              <EventManagerDays
                days={ [ displayDate ] }
                isViewMode={ true }
                calendarItem={ 1 }
                dataEventManager={ engagementsMap }
                getParticipantById={ getParticipantById }
                isDateInMap={ isDateInMap }
                setEventClick={ () => { return; } }
                setEventClicked={ () => { return; } }
                setIsDragging={ () => { return; } }
                isArchived={ false }
                isDragging={ false }
                eventManager={ currentEventManager }
                isPopupCreateEventVisible={ false }
                setIsPopupCreateEventVisible={ () => { return; } }
                refreshEngagementsOfEventManagerForDays={ () => { return; } }
                getNextDayNotClosed={ () => { return displayDate; } }
                isAdminOfEventManager={ false }
                canClickEng={ false }
                style={ StyleEventCard.line }
              />
            </div>

            <div className='2xl:fixed flex flex-col 2xl:w-[67%] p-4 2xl:p-2 2xl:right-0'>
              <VisualisationEventManagerCharts
                charts={ chartsDatas }
                safetyCross={ safetyCross }
              />
            </div>
          </>
        )
      }

    </div>
  );
}

export default VisualisationEventManagerBody;
